import { ReactNode, useState } from 'react'

import { ConfirmDialog } from '../../../components/ConfirmDialog'
import { useAppToast } from '../../../helpers'

interface IProps {
  isOpen: boolean
  onClose: () => void
  /** O que volta para pendente, dito por extenso: a linha inteira ou uma venda só. */
  description: ReactNode
  /** Faz a chamada e devolve quantas vendas voltaram; loading e toast são daqui. */
  onConfirm: () => Promise<{ removed: number }>
  onUndone: () => void
}

/**
 * Confirmação para desfazer uma baixa de pagamento.
 *
 * Apagar registro de pagamento não pode acontecer num clique só — nem o da linha inteira, que
 * derruba várias vendas de uma vez, nem o de uma venda dentro do modal. Quem chama diz o que
 * está em jogo e como desfazer; o diálogo é o mesmo nos dois casos.
 */
export default function CommissionPaymentUndoDialog({ isOpen, onClose, description, onConfirm, onUndone }: IProps) {
  const toast = useAppToast()
  const [isLoading, setIsLoading] = useState(false)

  const handleUndo = async () => {
    setIsLoading(true)
    try {
      const result = await onConfirm()

      toast.success(
        'Pagamento desfeito',
        `${result.removed} venda${result.removed === 1 ? '' : 's'} ${result.removed === 1 ? 'voltou' : 'voltaram'} para pendente.`
      )

      onUndone()
      onClose()
    } catch (error) {
      toast.error('Erro ao desfazer o pagamento', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <ConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleUndo}
      action="delete"
      title="Desfazer pagamento"
      description={description}
      confirmLabel="Desfazer"
      /* Desfazer não é irreversível: a baixa pode ser registrada de novo em seguida. */
      irreversible={false}
      isLoading={isLoading}
    />
  )
}
